import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProjetcsService} from '../../../projetcs.service';
import { GlobalService} from '../../../../shared/services/global.service';
import { FilterService} from '../../../../shared/services/filter.service';

@Component({
    selector: 'app-delete-scene-comment',
    templateUrl: './delete-scene-comment.component.html',
    styleUrls: ['./delete-scene-comment.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteSceneCommentComponent implements OnInit {
	@Input() comment:any;
	@Output() closeView  = new EventEmitter<string>();
	@Output() notify  = new EventEmitter<string>();

	close(){
		this.closeView.emit();
	}
	submitForm(){
		this._pS.deleteSceneComment(this.comment.id)
	  		.subscribe(
				data => {
					var vdata:any = data;
					this.notify.emit();
					
				}
			)
	}

  constructor(private _pS:ProjetcsService, public _gS:GlobalService, private _fS:FilterService, private datePipe:DatePipe) { }

  ngOnInit() {
  }

}
